import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import { RadioGroup, FormControlLabel, Radio } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import './ListRefreshDialog.scss'

const styles = {
  root: {
    '& .MuiTypography-root': {
      textAlign: 'center',
      fontFamily: '\'Roboto\', sans-serif',
      fontWeight: 'bold'
    }
  },
  labelStyle: {
    '& .MuiButtonBase-root': {
      padding: '3px',
      // fontFamily: '\'Roboto\', sans-serif'
      fontFamily: '\'DIN Pro Light\''
    }
  }
}
const refreshOptions = [
  { id: '1', value: ' Only the properties added/deleted from the list' },
  { id: '2', value: ' All Properties*' }
]

const ListRefreshDialog = props => {
  const {
    classes,
    isRefreshClicked,
    listName,
    cancelProjectRefreshHandler,
    confirmProjectRefreshHandler
  } = props
  const [refreshOption, setRefreshOption] = useState('')
  const refreshOptionChangeHandler = (event, value) => {
    event.persist()
    setRefreshOption(value)
  }

  return <div data-testid="list-refresh-dialog">
      <Dialog open={isRefreshClicked} aria-labelledby="refresh-confirm-dialog">
        <DialogTitle className={classes.root} id="refresh-confirm-dialog">
          {listName}
        </DialogTitle>
        <DialogContent>
          <div className="refresh-option-heading font-style">
            What data are you wanting to refresh?
          </div>
          <div>
            <RadioGroup name="refreshOption" value={refreshOption} onChange={refreshOptionChangeHandler}>
              {refreshOptions.map(rfOption => (
                <FormControlLabel
                  className={classes.labelStyle}
                  label={rfOption.value}
                  key={rfOption.id}
                  value={rfOption.id}
                  control={<Radio color="primary" />}
                />
              ))}
            </RadioGroup>
          </div>
          <div className="refresh-option-warning font-style">
            *Warning: This will overwrite any edits you have made
          </div>
        </DialogContent>
        <DialogActions>
          <div className="dialog-actions ">
            <Button className="action-btn" variant="contained" onClick={cancelProjectRefreshHandler} color="primary" size="large">
              Cancel
            </Button>
            <Button className="action-btn" variant="contained" onClick={() => confirmProjectRefreshHandler(refreshOption)} color="primary" size="large" disabled={!refreshOption}>
              Confirm
            </Button>
          </div>
        </DialogActions>
      </Dialog>
    </div>
}

ListRefreshDialog.propTypes = {
  classes: PropTypes.object,
  isRefreshClicked: PropTypes.bool,
  listName: PropTypes.string,
  cancelProjectRefreshHandler: PropTypes.func,
  confirmProjectRefreshHandler: PropTypes.func
}

export default withStyles(styles)(ListRefreshDialog)
